<template>
<v-container fluid>
  <v-row no-gutters>
    <v-col cols="12" align-self="end">
      <v-btn color="info" @click="addNew"  v-if="$can('do','POKO_WizytyZabiegi_Edycja')">Dodaj zabieg</v-btn>
    </v-col>
  </v-row>
  <v-row no-gutters>
    <v-col cols="12">
      <v-data-table
          :items="zagiegi"
          :headers="headers"
          hide-default-footer
          disable-pagination
          style="margin-bottom:200px"
      >
        <template v-slot:item="props">
          <tr>
            <td>{{props.item.nazwa}}</td>
            <td><div :style="{width:20+'px',height: 20+'px',backgroundColor:props.item.kolor}"></div></td>
            <td>{{props.item.dlugoscWizyty}}</td>
            <td>{{getKategoria(props.item)}}</td>
            <td>{{getPlacowkaNazwa(props.item.additionalOutposts)}}</td>
            <td>{{props.item.aktywny ? 'Tak' : 'Nie'}}</td>
            <td>
              <v-icon small class="mr-2" @click="editZabieg(props.item.id)" v-if="$can('do','POKO_WizytyZabiegi_Edycja')" title="Edytuj zabieg">fa-edit</v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
  <v-dialog fullscreen v-if="showAddEdit" v-model="showAddEdit" persistent>
    <ZabiegEdit :id="selectedId" v-if="showAddEdit" @close="showAddEdit = false" :kategorie="kategorieZabiegow" :placowki="dostepnePlacowki" @saved="saved"></ZabiegEdit>
  </v-dialog>

</v-container>
</template>

<script>
import {zabiegiService} from "@/services";
import {mapActions, mapState} from "vuex";
import ZabiegEdit from "@/components/zabiegi/ZabiegEdit";

export default {
  name: "ZabiegiLista",
  components: {ZabiegEdit},
  data() {
    return {
      zagiegi: [],
      kategorieZabiegow: [],
      headers: [
        {text: 'Nazwa zabiegu',  align: 'left', value: 'nazwa'},
        {text: 'Przypisany kolor', align: 'left', value:'kolor'},
        {text: 'Długośc wizyty',  align: 'left', value: 'dlugoscWizyty'},
        {text: 'Kategoria', align: 'left', value: 'kategoriaId'},
        {text: 'Przypisana placówki', sortable: false, align: 'left', value: 'additionalOutposts'},
        {text: 'Aktywny', align: 'left', value: 'aktywny'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      showAddEdit: false,
      selectedId: 0
    }
  },
  mounted() {
    this.refreshList()
    this.getKategorieZabiegow()
  },
  computed: {
    ...mapState('companySettingsModule',['settings']),
    dostepnePlacowki: function() {
      let placowki = []
      if(this.settings.additionalOutposts && this.settings.additionalOutposts.length > 0)
      {
        this.settings.additionalOutposts.forEach(elem => {
          placowki.push(elem)
        })
      }
      return placowki
    },
  },
  methods:
  {
    ...mapActions("alert", ["error", "success"]),
    getKategorieZabiegow()
    {
      zabiegiService.getKategorieZabiegow().then(result => {
        this.kategorieZabiegow = result.data.result
      }).catch(() => {
        this.error('Błąd pobierania listy kategorii zabiegów')
      })
    },
    getPlacowkaNazwa(lst)
    {
      let przypisanePlacowki = []

      if(lst!= null && lst.length > 0) {
        lst.forEach(elem=> {
          let pl = this.dostepnePlacowki.find(x => x.id == elem)
          if(pl)
            przypisanePlacowki.push(pl.name)
        })


      }
      return przypisanePlacowki.join(', ')
    },
    getKategoria(item)
    {
      if(item && item.kategoriaId && item.kategoriaId > 0)
      {
        let kategoria = this.kategorieZabiegow.find(x=>x.id == item.kategoriaId)
        return kategoria.nazwa
      }
      return '';
    },
    refreshList()
    {
      zabiegiService.getZabiegiList().then(result=> {
        this.zagiegi = result.data.result
      }).catch(() => {
        this.error('Błąd pobierania listy zabiegów')
      })
    },
    addNew()
    {
      this.selectedId = 0
      this.showAddEdit = true
    },
    saved()
    {
      this.refreshList()
      this.selectedId = 0
      this.showAddEdit = false
    },
    editZabieg(id)
    {
      this.selectedId = id
      this.showAddEdit = true
    }
  }
}
</script>

<style scoped>

</style>